import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'dispositivos',
})
export class DispositivosPipe implements PipeTransform {

  transform(items: any[], filter: any[]) {

    if(filter['id_local']){

      items = items.filter((item) => item.id_local == filter['id_local']);

    }

    return items;

  }

}



// WEBPACK FOOTER //
// ./src/pipes/dispositivos/dispositivos.ts